import {
  BotanicalFamiliesInterface,
  BotanicalOriginsInterface,
  CondimentInterface,
  LatinNamesInterface,
} from "./Condiment";
import { MixCategoryInterface } from "./Mix";

export enum MODAL_TYPES {
  PRODUCT_PREVIEW = "PRODUCT_PREVIEW",
  ALERT = "ALERT",
  CONFIRMATION = "CONFIRMATION",
  SWITCH_RECIPE_TYPE = "SWITCH_RECIPE_TYPE",
}

export enum MODAL_SIZES {
  XL = "xl",
  LG = "lg",
  SM = "sm",
}

export enum MODAL_ROOT_CAUSE {
  MIX_NAME_MISSING = "MIX_NAME_MISSING",
}

export interface ProductPreviewModalContentsInterface {
  type: string;
  title: string;
  description: string;
  history: string;
  recommendation: string;
  imageUrl: string;
  botanicalFamilies: BotanicalFamiliesInterface[];
  botanicalOrigins: BotanicalOriginsInterface[];
  latinNames: LatinNamesInterface[];
}
export interface MixPreviewModalContentsInterface {
  type: string;
  title: string;
  imageUrl: string;
  description: string;
  categories: MixCategoryInterface[];
  condiments: CondimentInterface[];
}

export interface ProductPreviewModalProps {
  modalContents: ProductPreviewModalContentsInterface;
}

export interface MixPreviewModalProps {
  modalContents: MixPreviewModalContentsInterface;
}

export interface ModalState {
  isOpen: boolean;
  modalType: MODAL_TYPES | null;
  content: { [key: string]: any };
  size: MODAL_SIZES | null;
  rootCause: MODAL_ROOT_CAUSE | null;
}

export interface OpenModalPayload {
  content: { [key: string]: any };
  modalType: MODAL_TYPES;
  size?: MODAL_SIZES;
  rootCause?: MODAL_ROOT_CAUSE;
}

export interface ModalHeaderProps {
  title: string;
  style: React.CSSProperties;
}

export interface ModalContentProps {
  children: React.ReactNode;
  style: React.CSSProperties;
}

export interface ModalControllerInterface {
  type: MODAL_TYPES;
  component: React.ReactNode;
}

export interface ModalContentListInterface {
  label: string;
  content: string;
}
